export const DataExplorer = (flujax) => ({
  async setSchedule (payload) {
    return flujax.post('/bulk/de/schedule/set', payload)
  },
  async getSchedule (bypassValidation) {
    let path = '/bulk/de/schedule/get'
    if (bypassValidation) {
      path += '?bypassValidation=true'
    }
    return flujax.post(path)
  },
  async apply (payload, applyOn, bypassValidation) {
    let path = '/bulk/de/apply'
    const params = []
    if (applyOn) {
      params.push(`applyOn=${applyOn}`)
    }
    if (bypassValidation) {
      params.push('bypassValidation=true')
    }
    if (params.length > 0) {
      path += `?${params.join('&')}`
    }
    return flujax.post(path, payload)
  },
  async interpret (payload) {
    return flujax.post('/bulk/de/schedule/interpret', payload)
  }
})
